export default ({
  fillExclamationMarkColor = '#FFF',
  color = '#FD4329',
  ...props
}) => (
  <svg {...props} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="20" height="20" />
      <path
        d="M10,2 C5.58133333,2 2,5.58186667 2,10 C2,14.4181333 5.58133333,18 10,18 C14.4181333,18 18,14.4181333 18,10 C18,5.58186667 14.4181333,2 10,2 L10,2 Z"
        fill={color}
        fillRule="nonzero"
      />
      <path
        d="M9.4756297,10.6660609 C9.59012103,11.1106288 10.4007197,11.1116543 10.5165195,10.6670864 L11,5.78401874 C11,5.3512445 10.5525025,5 10.0003271,5 C9.44815178,5 9,5.3512445 9,5.78401874 L9.4756297,10.6660609 Z"
        fill={fillExclamationMarkColor}
      />
      <path
        d="M10.0674397,13 L9.93256027,13 C9.4180653,13 9,13.447644 9,14 C9,14.552356 9.4180653,15 9.93256027,15 L10.0674397,15 C10.582545,15 11,14.552356 11,14 C11,13.447644 10.582545,13 10.0674397,13"
        fill={fillExclamationMarkColor}
      />
    </g>
  </svg>
);
